import { useNavigate } from 'react-router-dom'
import { AiDocumentsCard } from '@/app/dashboard/widgets'
import { formatDateShort } from '@/lib/format'
import { usePendingDocuments } from '../hooks'
import { SOURCE_LABEL } from '../labels'
import type { DocumentRow } from '../types'

/** „Dokumenty rozpoznane przez AI — do weryfikacji" (pulpit, design-main.png). */
export function AiInboxWidget() {
  const navigate = useNavigate()
  const pending = usePendingDocuments(4)

  const meta = (row: DocumentRow): string =>
    [
      SOURCE_LABEL[row.source],
      row.doc_type,
      row.detected_deadline ? `wykryty termin ${formatDateShort(row.detected_deadline)}` : null,
    ]
      .filter(Boolean)
      .join(' · ')

  return (
    <AiDocumentsCard
      loading={pending.isPending}
      moreHref="/dokumenty/skrzynka"
      items={(pending.data ?? []).map((row) => ({
        id: row.id,
        title: row.title,
        meta: meta(row),
        signature: row.case?.signature ?? row.suggested_case?.signature ?? null,
        confidence: row.confidence,
        onClick: () => navigate(`/dokumenty/weryfikacja/${row.id}`),
      }))}
    />
  )
}
